module.exports = require("@pb/kit-component-ellipsis-text-hint");